<template>
    <div class="ggmf-card upcoming-events-card">
        <div class="ggmf-card__header">
            <h4 class="ggmf-card__title">
                <i class="ri-calendar-2-line"></i>
                Próximos Eventos
            </h4>
            <router-link to="/calendar" class="ggmf-card__link">Ver todos</router-link>
        </div>
        <div class="ggmf-card__body">
            <!-- Loading -->
            <div v-if="loading">
                <div v-for="i in 3" :key="i" class="event-item-skeleton"></div>
            </div>

            <!-- Sem eventos -->
            <div v-else-if="!events.length" class="empty-state">
                <i class="ri-calendar-line"></i>
                <p>Nenhum evento futuro registado</p>
            </div>

            <!-- Lista de eventos -->
            <ul v-else class="events-list">
                <li v-for="event in events" :key="event.id" class="event-item">
                    <div class="event-item__cover">
                        <template v-if="event.coverImageUrl">
                            <video v-if="isVideo(event.coverImageUrl)" :src="event.coverImageUrl"
                                class="event-item__media"></video>
                            <img v-else :src="event.coverImageUrl" :alt="event.title_pt" class="event-item__media">
                        </template>
                        <div v-else class="event-item__date">
                            <span class="event-item__day">{{ formatDay(event.date) }}</span>
                            <span class="event-item__month">{{ formatMonth(event.date) }}</span>
                        </div>
                    </div>
                    <div class="event-item__info">
                        <h5 class="event-item__title">{{ event.title_pt }}</h5>
                        <p v-if="event.location" class="event-item__location">
                            <i class="ri-map-pin-line"></i>
                            {{ event.location }}
                        </p>
                    </div>
                    <div class="event-item__badge">
                        {{ formatTime(event.date) }}
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UpcomingEvents',
    props: {
        events: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        isVideo(url) {
            if (!url) return false;
            const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov'];
            return videoExtensions.some(ext => url.toLowerCase().includes(ext));
        },
        formatDay(dateStr) {
            return new Date(dateStr).getDate().toString().padStart(2, '0');
        },
        formatMonth(dateStr) {
            return new Date(dateStr).toLocaleDateString('pt-PT', { month: 'short' }).toUpperCase();
        },
        formatTime(dateStr) {
            return new Date(dateStr).toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' });
        },
    },
};
</script>

<style lang="scss">
.upcoming-events-card {
    margin-bottom: 24px;
    height: calc(100% - 24px);
}

.events-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.event-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 14px 0;
    border-bottom: 1px solid #F3F4F6;

    &:last-child {
        border-bottom: none;
    }

    &__cover {
        width: 48px;
        height: 48px;
        border-radius: 12px;
        overflow: hidden;
        flex-shrink: 0;
        background: #F3F4F6;

        .event-item__media {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    &__date {
        width: 100%;
        height: 100%;
        background: #EBF1FF;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    &__day {
        font-size: 18px;
        font-weight: 700;
        color: #1765FD;
        line-height: 1;
    }

    &__month {
        font-size: 9px;
        font-weight: 600;
        color: #1765FD;
        letter-spacing: 0.5px;
    }

    &__info {
        flex: 1;
        min-width: 0;
    }

    &__title {
        font-size: 14px;
        font-weight: 600;
        margin: 0 0 3px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &__location {
        font-size: 12px;
        color: #9ca3af;
        margin: 0;

        i {
            margin-right: 3px;
        }
    }

    &__badge {
        font-size: 11px;
        font-weight: 600;
        color: #1765FD;
        background: #EBF1FF;
        padding: 4px 10px;
        border-radius: 20px;
        white-space: nowrap;
    }
}

.event-item-skeleton {
    height: 62px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.2s infinite;
    border-radius: 12px;
    margin-bottom: 10px;
}
</style>
